import { Component, ViewEncapsulation } from '@angular/core';
import { LocaleService } from 'src/app/services/locale.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CookiePolicyComponent {
  templateContent: string;

  constructor(_http: HttpClient, localeService: LocaleService, router: Router) {
    const localizedTemplate = `/assets/templates/cookie-policy-${localeService.language}.template.html`;

    _http.get(localizedTemplate, { responseType: 'text' }).subscribe(
      (html) => (this.templateContent = html),
      (err) => router.navigate(['/'])
    );
  }
}
